module.exports = __webpack_public_path__ + "static/media/LOGO.e66e84c5.png";